// @flow
import * as React from 'react'
import type { GoogleMapsAPI, GoogleMap } from 'types/google_maps'
import MarkerHydrated from './Hydrated'
import type { Icon } from './icon'

type Props = {
  gMaps?: GoogleMapsAPI,
  map?: GoogleMap,
  lat: number,
  lng: number,
  icon: Icon,
  children?: React.Node,
}

export default class MapEmbedMarker extends React.Component<Props> {
  static defaultProps = {
    icon: 'pin',
  }

  render = () => {
    if (!this.props.gMaps || !this.props.map) return null

    return <MarkerHydrated {...this.props} />
  }
}
